/**
 * Boot scene — preloads all assets, then starts TitleScene.
 * Shows a thin progress bar.
 */
import Phaser from 'phaser';
import { Audio } from '../systems/AudioManager.js';

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  preload() {
    const w = this.cameras.main.width;
    const h = this.cameras.main.height;

    // Loading progress bar
    const barW = 240;
    const barH = 2;
    const barX = (w - barW) / 2;
    const barY = h * 0.55;
    const bg = this.add.rectangle(w / 2, barY, barW, barH, 0x3a2a4a);
    const fill = this.add.rectangle(barX, barY, 0, barH, 0xd4b08a).setOrigin(0, 0.5);
    const label = this.add.text(w / 2, barY - 20, 'preparing the garden', {
      fontFamily: 'Cormorant Garamond, serif',
      fontSize: '14px',
      color: '#6a5a4a',
      fontStyle: 'italic',
    }).setOrigin(0.5);

    this.load.on('progress', (p) => {
      fill.width = barW * p;
    });

    // Painted art — main backdrop
    this.load.image('garden_twilight', 'assets/art/garden_twilight.png');
    // Plant portraits
    this.load.image('plant_fig', 'assets/art/plant_fig.png');
    this.load.image('plant_blueberry', 'assets/art/plant_blueberry.png');
    this.load.image('plant_bulb', 'assets/art/plant_bulb.png');
    // Memory backdrops
    this.load.image('memory_wedding', 'assets/art/memory_wedding.png');
    this.load.image('memory_fig', 'assets/art/memory_fig.png');
    this.load.image('memory_blueberry', 'assets/art/memory_blueberry.png');
    this.load.image('memory_letter', 'assets/art/memory_letter.png');

    // Audio — music + voice
    Audio.preloadAll(this);

    // Silent fallback for missing assets
    this.load.on('loaderror', (file) => {
      console.warn('[Boot] missing:', file?.key || '?');
    });
  }

  create() {
    // Brief pause for the splash to feel intentional, then start title
    this.time.delayedCall(1000, () => {
      this.scene.start('TitleScene');
    });
  }
}
